// import { computed } from 'vue'
import dayjs from 'dayjs'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
const quarterOfYear = require('dayjs/plugin/quarterOfYear')
dayjs.extend(quarterOfYear)
export default function useTable (firstFriday, lastFriday) {
  const { t } = useI18n()
  const leftColumns = computed(() => ([
    {
      width: 150,
      title: t('shared.objective'),
      dataIndex: 'objectiveContent',
      fixed: 'left',
      // rowSpan: o => (!o.krIndex && o.krCount) || 0
      rowSpan: o => (o.krIndex === o.krCount - 1 && o.krCount) || 0
    },
    {
      width: 168,
      title: t('weekly.outputDesc'),
      dataIndex: 'objectiveDescription',
      fixed: 'left',
      // rowSpan: o => (!o.krIndex && o.krCount) || 0
      rowSpan: o => (o.krIndex === o.krCount - 1 && o.krCount) || 0
    },
    {
      width: 150,
      title: t('shared.keyResult'),
      dataIndex: 'krContent',
      fixed: 'left'
    },
    {
      width: 150,
      title: t('shared.indicator'),
      dataIndex: 'indicator',
      fixed: 'left'
    },
    {
      width: 110,
      title: t('shared.startDay'),
      dataIndex: 'startDay',
      fixed: 'left'
    },
    {
      width: 110,
      title: t('shared.finishDay'),
      dataIndex: 'endDay',
      fixed: 'left'
    },
    {
      width: 90,
      title: t('shared.progress'),
      dataIndex: 'progress',
      fixed: 'left'
    }
  ]))

  const columns = computed(() => {
    let end = lastFriday.value
    const quarterColumns = []
    while (end.isAfter(firstFriday.value)) {
      quarterColumns.push({
        title: end.format('YYYY-MM-DD'),
        children: [
          {
            width: 150,
            title: t('weekly.progress'),
            dataIndex: `week:${end.format('YYYY-MM-DD')}:currentProgress`
          },
          {
            width: 150,
            title: t('weekly.risk'),
            dataIndex: `week:${end.format('YYYY-MM-DD')}:currentRisk`
          },
          {
            width: 150,
            title: t('weekly.comments'),
            dataIndex: `week:${end.format('YYYY-MM-DD')}:remarks`
          }
        ]
      })
      end = end.subtract(1, 'week')
    }
    return leftColumns.value.concat(quarterColumns)
  })
  return {
    columns
  }
}
